// Chuck-clamp `machine_evidence` shape-oracle fixture — copied verbatim from the
// illustrative oracle in API_CONTRACTS.md ~2973-2995. ASPIRATIONAL numbers (SBL500
// live-PLC context, not MASH; the DYNAMIC card is not emitted this milestone —
// GAP-10). Exercises the OTHER-than-ARM branches of the SP-4 viewer: `measure_basis`
// DISPLAYED (status_bit / commanded / measured — GAP-11 shown when present), an
// `absent` supporting figure (measured RPM → "not available", NEVER a faked number),
// a string hero value ("TRUE"), a LIVE freshness banner, and a NON-`arm` deep-link
// target (`spindle_main`) → the deep-link chip is DISABLED when no sibling
// machine_card tab is open.
import type { MachineEvidenceArtifactData } from "../../../chatBot/models/machineEvidenceModels";

export const CHUCK_CLAMP_EVIDENCE_ORACLE: MachineEvidenceArtifactData = {
  schema_version: 1,
  mode: "snapshot",
  subsystem: "chuck_clamp",
  verdict: {
    status: "on_target",
    headline: "Chuck clamped: YES",
    detail: null,
    basis: "clamp status bit set",
  },
  hero: {
    id: "f_clamp",
    label: "Chuck clamped",
    value: "TRUE",
    unit: null,
    coverage: "ok",
    measure_basis: "status_bit",
    source_ref: "s_clamp",
    freshness: null,
  },
  supporting: [
    {
      id: "f_scmd",
      label: "Commanded spindle speed (S-word)",
      value: 1200,
      unit: "rpm",
      coverage: "ok",
      measure_basis: "commanded",
      source_ref: "s_spindle",
      freshness: null,
    },
    {
      id: "f_nact",
      label: "Measured spindle RPM",
      value: null,
      unit: "rpm",
      coverage: "absent",
      measure_basis: "measured",
      source_ref: "s_spindle",
      freshness: null,
    },
  ],
  trend: null,
  freshness: {
    state: "LIVE",
    as_of: "2026-06-28T10:00:05+02:00",
    last_sample_at: "2026-06-28T10:00:05+02:00",
    age_seconds: 0,
    source: "snapshot",
    provenance: "live",
    event_time: null,
  },
  sources: [
    {
      id: "s_clamp",
      signal_key: "I_CHUCK_CLAMPED",
      window: null,
      window_start: null,
      window_end: null,
      count: null,
      source_grain: "live_snapshot",
      read_source: "/read-tags",
      edge_path: "edge -> gateway -> bot",
    },
    {
      id: "s_spindle",
      signal_key: "DB33.DBD88",
      window: null,
      window_start: null,
      window_end: null,
      count: null,
      source_grain: "live_snapshot",
      read_source: "/read-tags",
      edge_path: "edge -> gateway -> bot",
    },
  ],
  links_to: { machine_card_tab: "spindle_main" },
  live: null,
  frozen: { is_frozen: false, frozen_at: null },
};
